/**
 * ModeSwitcher — 顶栏 Tabs：概览（默认） / 全展开 / 聚焦链
 */

import { memo } from 'react';

export type SkillTreeMode = 'overview' | 'all' | 'focus';

interface ModeSwitcherProps {
  mode: SkillTreeMode;
  onChange: (m: SkillTreeMode) => void;
}

const TABS: Array<{ key: SkillTreeMode; label: string; tip: string }> = [
  { key: 'overview', label: '概览', tip: '关键节点 + 主干路径' },
  { key: 'all', label: '全展开', tip: '全部节点 + 全部边' },
  { key: 'focus', label: '聚焦链', tip: '仅当前选中链' },
];

const ModeSwitcher = memo(function ModeSwitcher({ mode, onChange }: ModeSwitcherProps) {
  return (
    <div style={{
      position: 'absolute', top: 12, left: 12, zIndex: 10,
      display: 'flex', gap: 4,
      background: 'rgba(15,23,42,0.85)',
      border: '1px solid #334155',
      borderRadius: 8, padding: 4,
    }}>
      {TABS.map(t => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          title={t.tip}
          style={{
            padding: '5px 12px',
            borderRadius: 5,
            border: 'none',
            background: mode === t.key ? '#3b82f6' : 'transparent',
            color: mode === t.key ? 'white' : '#cbd5e1',
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 500,
            transition: 'background 0.15s',
          }}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
});

export default ModeSwitcher;
